module.exports = __webpack_public_path__ + "img/mazda-5050-preview.2c45b42a.png";